import { render, staticRenderFns } from "./PmtSrc.vue?vue&type=template&id=74ff8adc"
import script from "./PmtSrc.vue?vue&type=script&lang=js"
export * from "./PmtSrc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports